import WebMidi, {
  Input,
  InputEventNoteon,
  IEventNote,
  InputEventNoteoff
} from "webmidi";
import { INoteValue, Note } from "piano-chart";

export interface MidiInputInfo {
  id: string;
  name: string;
}

export class MIDIKeyboard {
  public static inputs: Input[] = [];
  public static currentInput?: Input;
  private static noteOnListeners: ((note: INoteValue) => void)[] = [];
  private static noteOffListeners: ((note: INoteValue) => void)[] = [];

  public static init(callback: (inputs?: Input[], err?: Error) => void) {
    WebMidi.enable(function(err) {
      if (err) {
        console.log("WebMidi could not be enabled.", err);
        callback(undefined, err);
      } else {
        MIDIKeyboard.inputs = WebMidi.inputs;
        callback(MIDIKeyboard.inputs);
      }
    });
  }

  public static shutdown() {
    if (WebMidi.enabled) {
      WebMidi.disable();
    }
  }

  public static releaseCurrent() {
    MIDIKeyboard.removeNoteListeners();
    MIDIKeyboard.noteOnListeners.splice(0);
    MIDIKeyboard.noteOffListeners.splice(0);
  }

  public static addNoteOnListener(listener: (note: INoteValue) => void) {
    MIDIKeyboard.noteOnListeners.push(listener);
  }
  public static addNoteOffListener(listener: (note: INoteValue) => void) {
    MIDIKeyboard.noteOffListeners.push(listener);
  }

  public static setCurrentInput(inputId: string) {
    if (this.inputs && this.inputs.findIndex(i => i.id === inputId) > -1) {
      MIDIKeyboard.currentInput = this.inputs.find(i => i.id === inputId);
      MIDIKeyboard.addNoteListeners();
    }
  }

  private static addNoteListeners() {
    if (MIDIKeyboard.currentInput) {
      MIDIKeyboard.currentInput.addListener(
        "noteon",
        "all",
        MIDIKeyboard.handleNoteOn
      );
      MIDIKeyboard.currentInput.addListener(
        "noteoff",
        "all",
        MIDIKeyboard.handleNoteOff
      );
    }
  }

  private static removeNoteListeners() {
    if (MIDIKeyboard.currentInput) {
      MIDIKeyboard.currentInput.removeListener(
        "noteon",
        "all",
        MIDIKeyboard.handleNoteOn
      );
      MIDIKeyboard.currentInput.removeListener(
        "noteoff",
        "all",
        MIDIKeyboard.handleNoteOff
      );
    }
  }

  private static handleNoteOn(ev: InputEventNoteon) {
    const note = MIDIKeyboard.noteToNote(ev.note);
    MIDIKeyboard.noteOnListeners.forEach(l => l(note));
  }

  private static handleNoteOff(ev: InputEventNoteoff) {
    const note = MIDIKeyboard.noteToNote(ev.note);
    MIDIKeyboard.noteOffListeners.forEach(l => l(note));
  }

  private static noteToNote(wmNote: IEventNote): INoteValue {
    return {
      note: wmNote.name[0] as Note,
      accidental: wmNote.name.length > 1 ? "#" : undefined,
      octave: wmNote.octave
    };
  }
}
